export default status => {
  if (status === 'PROCESSING') {
    return '#e2e2e2';
  } if (status === 'SUCCESS') {
    return '#ececff';
  } if (status === 'FAILURE') {
    return '#ff858d';
  } return '#ffe0b1';
};
